
angular.module('app.directives.tab_select', []).directive('tabSelect', ['$log','$timeout', function ($log, $timeout) {
  return {
    restrict: 'EA',
    replace: 'false',
    scope: false,
    templateUrl: 'templates/tab-select.html',
    link: function($scope, $elem, attrs) {
      $timeout(function () {
        var section = 1;
        var headers = $elem.closest("div[ng-controller='TabSelectController']").find('div.show-one').map(function(){
          var title = $(this).find('div.black-small-header-text:first-child').attr('data-label');
          if (title) return title;

          title = $(this).find('.anchor:first-child').attr('data-flyout');
          if (title) return title;

          title = $(this).find('div[static-popover]:first-child').attr('static-popover');
          if (title) return title;

          return 'Section ' + section++;
        });
        $scope.types = headers;
      });

      $scope.setType = function(value) {
        if (value == $scope.typeSelection)
          return;
        $scope.shows[$scope.typeSelection] = false;
        $scope.typeSelection = value;
        $scope.shows[$scope.typeSelection] = true;
      };
    }
  };
}]);